import { gql } from '@apollo/client';

const deleteAgentFile = gql`
  mutation ($agent_id: String!, $file_id: Int!) {
    deleteAgentFile(agent_id: $agent_id, file_id: $file_id)
  }
`;
export default deleteAgentFile;
